"use client"

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
  } from "@/components/ui/accordion"
import { homeFAQ } from "@/lib/constants"
import { OutCallsModal } from "../modals/OutCallsModal"
import { useMediaQuery } from "usehooks-ts";

export const HomeFAQ = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    return (
        <Accordion type="single" collapsible className={`w-full max-w-screen-lg mx-auto ${isMobile ? "p-4" : ""}`}>
            {homeFAQ.map((faq, index) => (
                <AccordionItem value={`item-${index}`} key={index}>
                    <AccordionTrigger className={`text-start ${isMobile ? "text-base" : "text-xl"} font-semibold hover:no-underline`}>{faq.title}</AccordionTrigger>
                    <AccordionContent className="flex flex-col items-start gap-2 text-start">{faq.answer} {faq.conditions && <OutCallsModal isMobile={isMobile} />}</AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    )
}